// extracted by mini-css-extract-plugin
export default {"external-link":"external-link__k66kH"};